import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { GuardModel, IncidentGuardModel, IncidentModel, ModuleModel } from '../../../models';
import { AuthenticationService, ModuleService, TenantService, Type3Service } from '../../../services';
import { CustomTypeService } from '../../../services/custom-type.service';
import { GuardService } from '../../../services/guard.service';
import { IncidentTypeService } from '../../../services/incident-type.service';
import { IncidentService } from '../../../services/incident.service';
import { SettingsService } from '../../../services/settings.service';
import { SiteService } from '../../../services/site.service';

@Component({
    selector: 'app-daily-report-create',
    templateUrl: './daily-report-create.component.html',
    styleUrls: ['../../layout/layout.component.scss', '../../layout/mobile.css'],
    animations: [
        trigger('slideIn', [
            state('*', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            state('void', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            transition('* => void', [
                style({ height: '*' }),
                animate(300, style({ height: 0 }))
            ]),
            transition('void => *', [
                style({ height: '0' }),
                animate(300, style({ height: '*' }))
            ])
        ])
    ]
})
export class MobileDailyReportCreateComponent implements OnInit {
    sending: boolean = false;
    AllGuards: any[];
    isTenantRequired: any;
    WithSpecialOption: boolean = false;
    tenants: any[];
    type3List: any[];
    accountSetting: any[] = [];
    customTypes: any[];
    incidenttypes: any[];
    GuardText: any;
    SelectedGuards: any[] = [];
    Guards: any;
    model: IncidentModel;
    step: number = 1;
    module: ModuleModel;
    SiteId: number = 0;
    role: any = {
        Name: '',
        Description: ''
    };
    sitesList: any[];
    type1: string = "Type 1";
    type2: string = "Type 2";
    type3: string = "Type 3";
    currentUser: any;
    showSpinners: boolean = false;

    constructor(private siteService: SiteService, private router: Router, private settingService: SettingsService, private guardService: GuardService,
        private incidentTypeService: IncidentTypeService, private customTypeService: CustomTypeService,
        private type3Service: Type3Service,
        private authenticationService: AuthenticationService,
        private moduleService: ModuleService,
        private tenantService: TenantService, private incidentService: IncidentService,
        private route: ActivatedRoute, private toastr: ToastsManager) { }

    ngOnInit() {
        this.model = new IncidentModel();
        var now = new Date();
        this.model.TimeDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
        this.model.TimeHour = <NgbTimeStruct>{ hour: now.getHours(), minute: now.getMinutes(), second: now.getSeconds() };
        this.loadGuards();
        this.loadAllGuards();
        this.loadSites();
        this.loadSetting();
        this.loadIncidentTypes();
        this.loadType3();
        this.loadCustomTypes();
        this.loadTenant();
        this.loadBlueLightOption();
        this.loadRoleDailyReport();
    }

    getSite() {
        if (this.sitesList != undefined) {

            return this.sitesList.filter(x => x.Id == this.model.SiteId)[0].Name;
        }

    }

    loadBlueLightOption() {
        //  
        var moduleId = 6;
        this.settingService.getSettings(this.currentUser.accountId, moduleId, 0)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.accountSetting = response.Data;

            });
    }

    loadReport(id: number) {

        var tempValue = this.accountSetting.filter(r => r.Name == "WithSpecialOption")[0].Value;

        if (tempValue == "false") {
            this.WithSpecialOption = false;
        } else {
            // 
            var tempValueOption = this.accountSetting.filter(r => r.Name == "SpecialOptions")[0].Value;
            var ids = ("" + tempValueOption).split(',');

            var data = ids.filter(r => r == ("" + this.model.Type1Id));
            if (data != null && data != undefined && data.length != 0) {
                this.WithSpecialOption = true;
            } else {
                this.WithSpecialOption = false;
            }

        }

    }

    type3Changed() {
        if (this.model.Type3Id != 0 && this.model != undefined && this.model.Type3Id != undefined) {
            this.type3Service.getType3(this.model.Type3Id).catch((err: any) => {
                return Observable.throw(err);
            })
                .finally(() => {
                    setTimeout(() => {
                        // this.showSpinner = false;
                    }, 1000);
                })
                .subscribe((response: any) => {

                    this.isTenantRequired = response.Data.IsTenantRequired;
                    console.log(this.isTenantRequired);
                    this.loadTenantById(response.Data.TenantTypeId);
                });
        } else {
            this.isTenantRequired = false;
        }
    };

    public saveChanges(): void {

        if (this.model.ActionDescription == "" || this.model.ActionDescription == undefined) {
            this.toastr.warning("Description is required", "Error");
            return;

        }

        if (this.SelectedGuards.length == 0) {
            this.toastr.warning("A guard is required", "Error");
            return;
        }

        //this.showSpinner = true;
        this.sending = true;
        this.model.IncidentGuard = [];

        this.SelectedGuards.forEach((guard) => {
            var incidentGuardmodel = new IncidentGuardModel();
            incidentGuardmodel.GuardId = guard.Id;

            if (guard.Id == 0) {

                incidentGuardmodel.Guard = new GuardModel();
                incidentGuardmodel.Guard.Name = guard.Name;
                incidentGuardmodel.Guard.SiteId = this.SiteId;
            }
            this.model.IncidentGuard.push(incidentGuardmodel);

        });

        //this.model.Reports = this.Reports;
        this.model.AccountId = this.currentUser.accountId;
        this.model.SiteId = this.SiteId;

        //console.log(this.model.Reports);
        this.incidentService.saveIncident(this.model)
            .catch((err: any) => {
                //this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    // this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                if (response.ErrorCode) {
                    //this.toastr.error(response.Message, "Error"); 
                }
                else {
                    // this.toastr.success(response.Message, "Success"); 
                }

                this.sending = false;
                this.toastr.success(response.Message, "Success");
                this.ngOnInit();
            });
    }

    loadTenant() {

        this.SiteId = +localStorage.getItem('currentSiteId');
        //this.loadingTenant = true;
        this.model.TenantId = 0;
        this.tenants = [];
        this.tenantService.getTenantBySiteId(this.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    // this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.tenants = response.Data;
                this.loadAllGuards();
                this.loadGuards();
                // this.toastr.success(response.Message, "Success"); 
            });

    }



    loadTenantById(tenantTypeId: number) {
        //  
        // this.loadingTenant = true;
        this.model.TenantId = 0;
        this.tenants = [];
        this.tenantService.getTenantByTenantTypeId(this.SiteId, tenantTypeId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.tenants = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });

    }

    loadSites() {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.siteService.getSitesByAccountList(this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.sitesList = response.Data;
                //  this.toastr.success(response.Message, "Success"); 
            });
    }

    navigateToLanding() {
        this.router.navigate([`mobile`]);
    }

    search = (text$: Observable<string>) => {
        return text$
            .debounceTime(200)
            .map(term => term === '' ? []
                : this.Guards.filter(v => v.Name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

    };

    addNewGuard(text: string) {
        if (text != '') {
            var model = new GuardModel();
            model.Name = text;
            model.Id = 0;
            this.SelectedGuards.push(model);
            this.GuardText = "";
            this.formatter = (x: GuardModel) => "";
        }
    }

    selectGuard(guardId: number, guardName: string) {
        this.removeGuard(guardId);
        var model = new GuardModel();
        model.Name = guardName;
        model.Id = guardId;
        this.SelectedGuards.push(model);

        this.GuardText = "";
        this.formatter = (x: GuardModel) => "";
    }
    navigateToStep(step: number) {
        // 
        if (this.model.Type1Id == 0 || this.model.Type1Id == undefined) {
            this.toastr.warning(this.type1 + " is required", "Error");
            return;
        }

        if (this.model.Type2Id == 0 || this.model.Type2Id == undefined) {
            this.toastr.warning(this.type2 + " is required", "Error");
            return;
        }

        if (this.WithSpecialOption) {
            if (this.model.WithBlueLight == null || this.model.WithBlueLight == undefined) {
                this.toastr.error("Error", "Blue light option is a required field");
                return;
            }

            if (this.model.BlueLightOption == null || this.model.BlueLightOption == undefined || this.model.BlueLightOption == "") {
                this.toastr.error("Error", "Blue light option is a required field");
                return;
            }
        }

        this.step = step;

    };


    loadRoleDailyReport() {
        // 
        this.moduleService.getModuleByTitle("Daily Report")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                this.module = response.Data;

                // 
                //let currentUser = super.currentLoggedUser();

                var currentUser = JSON.parse(localStorage.getItem('currentUser'));
                this.authenticationService.getRole(currentUser.id, this.module.Id, this.SiteId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.role = response.Data;

                        //this.incidentList.role = this.role;
                    });


            });
    };

    removeGuard(id) {

        for (let i = 0; i < this.SelectedGuards.length; i++) {
            if (this.SelectedGuards[i].Id === id) {
                this.SelectedGuards.splice(i, 1);
                break;
            }
        }

    };

    formatter = (x: GuardModel) => x.Name;


    loadSetting() {
        //var currentUser = super.currentLoggedUser();
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getValue("type1", this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type1 = response.Data.Value;
                }
            });


        this.settingService.getValue("type2", this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type2 = response.Data.Value;
                }
            });


        this.settingService.getValue("type3", this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type3 = response.Data.Value;
                }

            });

    }

    loadGuards() {
        this.Guards = [];

        var timeDate = this.model.TimeDate;
        var dateToPass = timeDate.year + '-' + timeDate.month + '-' + timeDate.day;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        var dateToPass = timeDate.year + '-' + timeDate.month + '-' + timeDate.day;
        this.guardService.getAllGuardsByDayAndAccount(dateToPass, this.currentUser.accountId, this.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //  this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.Guards = response.Data;
                //this.toastr.success(response.Message, "Success"); 
            });
    };

    loadAllGuards() {
        this.guardService.getGuardEmployees(this.currentUser.accountId, this.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.AllGuards = response.Data;
                //this.toastr.success(response.Message, "Success"); 
            });
    }

    loadIncidentTypes() {
        this.incidenttypes = [];
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('currentSiteId');
        this.incidentTypeService.getAllIncidentTypes(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    // this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.incidenttypes = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });
    };

    loadCustomTypes() {
        this.customTypes = [];
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('currentSiteId');
        this.customTypeService.getAllCustomTypes(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //  this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.customTypes = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });
    };

    public loadType3() {

        this.type3List = [];
        this.type3Service.getAllType3(this.currentUser.accountId, this.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.type3List = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });
    }

    test() {
        throw new Error("not Implemented"); // todo: not implemented
    }
}



// WEBPACK FOOTER //
// ./src/app/components/mobile/daily-report/daily-report-create.component.ts